import { Component, Input, OnInit } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { ApiService } from '../../../Services/api.service';
import { NzCheckboxComponent } from "ng-zorro-antd/checkbox";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-filter-criteria',
  standalone: true,
  imports: [NzButtonModule, NzRadioModule, CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './filter-criteria.component.html',
  styleUrl: './filter-criteria.component.scss'
})
export class FilterCriteriaComponent implements OnInit {

  constructor(private apiService: ApiService) {
  }
  filterCriteriaData: any;
  @Input() catalogId: string = '';
  sizeAvailable: boolean = false;
  byGender: boolean = false;

  ngOnInit() {
    this.apiService.getFilterCriteria(this.catalogId).subscribe(res => {
      this.filterCriteriaData = res;
      this.filterCriteriaData.sizeAvailable == 1 ? this.sizeAvailable = true : this.sizeAvailable = false;
      this.filterCriteriaData.byGender == 1 ? this.byGender = true : this.byGender = false;
    })
  }

  updateFilterCriteria() {
    this.sizeAvailable == true ? this.filterCriteriaData.sizeAvailable = 1 : this.filterCriteriaData.sizeAvailable = 0;
    this.byGender == true ? this.filterCriteriaData.byGender = 1 : this.filterCriteriaData.byGender = 0;
    this.filterCriteriaData.actionUser = "MOJOADM1";
    this.apiService.updateFilterCriteria(this.catalogId, this.filterCriteriaData).subscribe(res => {
        this.apiService.createNotification('success', res?.message);
        this.ngOnInit();

    },err=>{
       this.apiService.createNotification('error', err?.error?.message);
    })
  }

}
